import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import AppContext from '../context/AppContext';
import { Input, Loader } from '../components';
import bg from '../assets/images/bg.jpg';

import useApi from '../hooks/useApi';
import profileApi from '../api/profile';

export default function CreateProfile() {
  const {
    currentAccount,
    connectWallet,
    theme,
    isMember,
    hasLoaded,
    isLoggedIn,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [error, setError] = useState();

  const createProfile = useApi(profileApi.createProfile);

  console.log(
    'CHECKING ISLOGGEDIN AND ISMEMBER CREATE_PROFILE',
    isLoggedIn,
    isMember
  );

  useEffect(() => {
    if (hasLoaded) {
      if (isLoggedIn && isMember) {
        navigate('/');
      } else {
      }
    }

    if (createProfile?.success) {
      navigate('/');
    }
  }, [isMember, isLoggedIn, hasLoaded, createProfile?.success]);
  const submitHandler = async () => {
    createProfile.request({ handle: username });
    console.log('CREATE DATA', createProfile);
  };
  return (
    <StyledCreateProfile theme_={theme} img={bg}>
      <Loader visible={createProfile?.loading} />
      <div className="create-container">
        <span className="title">
          <h2>Create Profile</h2>
        </span>

        <Input
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Enter a Unique Username"
          name="Username"
          label="Username"
          theme={theme}
          asterik={true}
          error={error}
        />
        <span>
          <button onClick={submitHandler}>Submit</button>
        </span>
      </div>
    </StyledCreateProfile>
  );
}

const StyledCreateProfile = styled(motion.div)`
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
  background-image: url(${({ img }) => img});
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  @media screen and (max-width: 900px) {
    padding: 0.5rem;
  }
  .create-container {
    height: auto;
    width: 30rem;
    border-radius: 0.5rem;
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    padding: 1rem;
    display: flex;
    flex-flow: column wrap;
    background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
    .title {
      padding: 1rem 0rem;
    }
    @media screen and (max-width: 900px) {
      width: 100%;
    }
  }
`;
